var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78356 0C10.3358 0 10.7836 0.447715 10.7836 1L10.7836 19C10.7836 19.5523 10.3358 20 9.78356 20C9.23127 20 8.78356 19.5523 8.78356 19V16H7C6.44772 16 6 15.5523 6 15C6 14.4477 6.44772 14 7 14H8.78356V11H4C3.44772 11 3 10.5523 3 10C3 9.44771 3.44772 9 4 9H8.78356V6L1 6C0.447715 6 0 5.55228 0 5C5.96046e-08 4.44771 0.447715 4 1 4L8.78356 4V1C8.78356 0.447715 9.23127 0 9.78356 0ZM12 5C12 4.44772 12.4477 4 13 4H15C15.5523 4 16 4.44772 16 5C16 5.55228 15.5523 6 15 6H13C12.4477 6 12 5.55228 12 5ZM12 10C12 9.44771 12.4477 9 13 9H18C18.5523 9 19 9.44771 19 10C19 10.5523 18.5523 11 18 11H13C12.4477 11 12 10.5523 12 10ZM12 15C12 14.4477 12.4477 14 13 14H21C21.5523 14 22 14.4477 22 15C22 15.5523 21.5523 16 21 16H13C12.4477 16 12 15.5523 12 15Z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/ScheduleIcon.bbf4105feccee2b6b22eb581686f59f9.svg";
export { ForwardRef as ReactComponent };